import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import React, { useRef } from "react";
import { Link } from "react-router";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Input } from "@/components/ui/input";

const SignUp: React.FC = () => {
    //refs
    const emailRef = useRef<HTMLInputElement>(null);

    //kinde
    const { register } = useKindeAuth();
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="flex min-h-min items-center justify-center text-gray-700 lg:min-h-screen">
                <div>
                    <Card className="mt-4 min-w-[400px] rounded-lg border-none px-6 py-10 text-gray-700 shadow-none">
                        <div className="mb-10 flex flex-col items-center">
                            {/* Update the logo to use Google's logo or your own brand logo */}
                            <img loading="lazy" decoding="async" fetchPriority="low" src="/assets/images/logo/shoe-ai-logo.png" alt="Logo" />
                            <h3 className="my-2 text-xl font-bold">Create a New Account</h3>
                            <p className="text-sm font-semibold">
                                Already an Account?{" "}
                                <Link className="text-blue-600" to={"/auth/sign-in"}>
                                    Sign in
                                </Link>
                            </p>
                        </div>
                        <div className="mt-2 block">
                            <Input ref={emailRef} placeholder="Enter Email Address" className="py-6 mb-2 outline-blue-400" />
                            <Button
                                className="w-full bg-blue-500 py-6 hover:bg-blue-600 cursor-pointer"
                                onClick={() => {
                                    register({
                                        authUrlParams: {
                                            connection_id: import.meta.env.VITE_KINDE_EMAIL_CONNECTION_ID,
                                            login_hint: emailRef.current?.value,
                                        },
                                    });
                                }}
                            >
                                Next
                            </Button>
                            <p className="mb-2 text-center text-sm">or</p>
                            <Button
                                onClick={() =>
                                    register({
                                        authUrlParams: {
                                            connection_id: import.meta.env.VITE_KINDE_GOOGLE_CONNECTION_ID,
                                        },
                                    })
                                }
                                className="flex w-full items-center gap-4 py-6 text-base cursor-pointer"
                                variant={"secondary"}
                            >
                                <svg
                                    viewBox="-26.2 -26.2 314.40 314.40"
                                    xmlns="http://www.w3.org/2000/svg"
                                    preserveAspectRatio="xMidYMid"
                                    fill="#000000"
                                    stroke="#000000"
                                    strokeWidth="0.00262"
                                >
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g
                                        id="SVGRepo_tracerCarrier"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        stroke="#CCCCCC"
                                        strokeWidth="1.048"
                                    ></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
                                            fill="#4285F4"
                                        ></path>
                                        <path
                                            d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
                                            fill="#34A853"
                                        ></path>
                                        <path
                                            d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
                                            fill="#FBBC05"
                                        ></path>
                                        <path
                                            d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
                                            fill="#EB4335"
                                        ></path>
                                    </g>
                                </svg>
                                Sign in with Google
                            </Button>
                        </div>
                    </Card>
                </div>
            </div>
            <div className="p-4">
                <div className="flex size-full items-center justify-center rounded-xl border border-gray-300 bg-gray-200">
                    <img src={"/assets/images/illustrations/chat_bot_signup.png"} height={400} width={400} alt="chat bot login" />
                </div>
            </div>
        </div>
    );
};

export default SignUp;
